
export interface DMCoSo {
    id: number;
    maCoSo: string;
    tenCoSo: string;
    thuTuHienThi: number;
}

export interface DMBopPhanKiemKe {
    id: number;
    ma: string;
    ten: string;
    nhomCap1: string;
    nhomCap2?: string;
    loaiDoiTuong: number;
    thuTuHienThi: number;
}

export interface DotKiemKeThanhVien {
    id?: number;
    idDotKiemKe?: number;
    idNhanVien?: number;
    hoTen: string;
    tenChucVu?: string;
    vaiTro: string;
    thuTu: number;
}

export interface TaiSan {
    id?: number;
    ma: string;
    maKeToan?: string;
    tenTaiSan: string;
    idLoaiTaiSan: number;
    loaiTaiSan?: string;
    idCoSo?: number;
    tenCoSo?: string;
    idBoPhan?: number;
    tenBoPhan?: string;
    idDonVi: number;
    tenDonVi?: string;
    idNVSuDung?: number;
    nguoiSuDung?: string;
    viTriSuDung?: string;
    soLuongTaiSanPhu?: number;
    ngayTang?: Date;
    ngayDuaVaoSuDung?: Date;
    ngayNhapKho?: Date;
    soNamPhanBo: number | null;
    soKyPhanBo?: number | null;
    soKyDaPhanBo?: number | null;
    giaTriKhiNhap?: number;
    nguyenGia?: number;
    giaTriDaPhanBo?: number;
    giaTriConLai?: number;
    trangThai: number;
    maQR?: string;
    soSerial?: string;
    nhaCungCap?: string;
    soLuong: number;
    donViTinh?: string;
    thoiGianBaoHanh?: number;
    moTa?: string;
    ghiChu?: string;
    tinhTrang?: number;
    idTaiSanChinh?: number | null;
    dsTaiLieu?: TaiLieuTaiSan[];
    dsTaiSanPhu?: TaiSan[];
}

export interface ChiTietTaiSan extends TaiSan {
    dsLichSu?: LichSuSuDungTaiSan[];
}

export interface TaiLieuTaiSan {
    idTaiLieu: number;
    tenTep: string;
    duongDan: string;
    loaiFile?: string;
    kichThuoc?: number;
    moTa?: string;
}

export interface LichSuSuDungTaiSan {
    id: number;
    ngayThayDoi: Date;
    loaiThayDoi: number;
    tenLoaiThayDoi: string;
    nguoiThucHien: string;
    nguoiNhan?: string;
    noiDung: string;
    trangThaiCu?: number;
    trangThaiMoi?: number;
}

export interface ThongKeTaiSan {
    tongTaiSan: number;
    dangSuDung: number;
    tamDungSuDung: number;
    suaChua: number;
    baoTri: number;
    dieuChuyen: number;
    choThanhLy: number;
    tongGiaTri: number;
}

export interface TaiSanRequest {
    files: any[];
    id?: number;
    ma: string;
    maKeToan?: string;
    tenTaiSan: string;
    idLoaiTaiSan: number;
    idCoSo?: number;
    idBoPhan?: number;
    idDonVi: number;
    idDonViQuanLy?: number;
    idDonViSuDung?: number;
    idNVSuDung?: number;
    viTriSuDung?: string;
    ngayTang?: string;
    ngayDuaVaoSuDung?: string;
    ngayNhapKho?: string;
    soNamPhanBo?: number | null;
    soKyPhanBo?: number | null;
    soKyDaPhanBo?: number | null;
    giaTriKhiNhap?: number;
    nguyenGia?: number;
    giaTriDaPhanBo?: number;
    giaTriConLai?: number;
    trangThai: number;
    soSerial?: string;
    nhaCungCap?: string;
    soLuong: number;
    thoiGianBaoHanh?: number;
    moTa?: string;
    idsTaiLieuTaiSanXoa?: number[];
    idTaiSanChinh?: number | null;
}

export interface TimKiemTaiSanRequest {
    tuKhoa?: string;
    idLoaiTaiSan?: number;
    idCoSo?: number;
    idBoPhan?: number;
    idDonVi?: number;
    trangThai?: number;
}

export enum TrangThaiTaiSan {
    MoiNhap = 0,
    DangSuDung = 1,
    BaoTri = 2,
    Hong = 3,
    ChoThanhLy = 4,
    DieuChuyen = 5,
    DaThanhLy = 6
}

export interface TaiSanKiemKe {
    id: number;
    ma: string;
    maKeToan?: string;
    maHienThi: string;
    tenTaiSan: string;
    idLoaiTaiSan: number;
    loaiTaiSan: string;
    idCoSo?: number;
    tenCoSo?: string;
    idBoPhan?: number;
    tenBoPhan?: string;
    tenDonVi?: string;
    nguoiSuDung?: string;
    viTriSuDung?: string;
    trangThai: number;
    maQR?: string;
    idKetQuaKiemKe?: number;
    trangThaiKiemKe: number;
    phuongThucKiemKe?: number;
    tinhTrangSuDung?: number;
    ghiChuKiemKe?: string;
    nguoiKiemKe?: string;
    thoiGianKiemKe?: Date;

    soLuongSoSach: number;
    nguyenGiaSoSach: number;
    gtDaPhanBoSoSach: number;
    gtConLaiSoSach: number;

    soLuongThucTe: number;
    nguyenGiaThucTe: number;
    gtDaPhanBoThucTe: number;
    gtConLaiThucTe: number;

    chenhLechSoLuong: number;
    chenhLechNguyenGia: number;
    chenhLechGtConLai: number;
}

export interface ThongKeKiemKe {
    tongTaiSan: number;
    daKiemKe: number;
    chuaKiemKe: number;
    dangSuDung: number;
    khongSuDung: number;
}

export interface BaoCaoKiemKe {
    stt: number;
    tenLoaiTaiSan: string;
    danhSachMa: string;
    soLuongKyTruoc: number;
    soLuongTang: number;
    soLuongGiam: number;
    soLuongHienTai: number;
    dangSuDung: number;
    khongSuDung: number;
    ghiChu?: string;
}

export interface LuuKetQuaKiemKeRequest {
    idDotKiemKe: number;
    idTaiSan: number;
    trangThaiKiemKe: number;
    phuongThucKiemKe: number;
    tinhTrangSuDung?: number;
    ghiChuKiemKe?: string;
    soLuongSoSach?: number;
    nguyenGiaSoSach?: number;
    gtDaPhanBoSoSach?: number;
    gtConLaiSoSach?: number;
    soLuongThucTe?: number;
    nguyenGiaThucTe?: number;
    gtDaPhanBoThucTe?: number;
    gtConLaiThucTe?: number;
    idBoPhanThucTe?: number;
}

export interface TimKiemTaiSanKiemKeRequest {
    idDotKiemKe: number;
    tuKhoa?: string;
    idLoaiTaiSan?: number;
    idCoSo?: number;
    idBoPhan?: number;
    trangThaiKiemKe?: number;
    tinhTrangSuDung?: number;
}

export enum LoaiThayDoiTaiSan {
    KhoiTao = 0,
    CapNhat = 1,
    Xoa = 2,
    BanGiao = 3,
    ThuHoi = 4,
    BaoTri = 5,
    SuaChua = 6,
    KiemKe = 7,
    ThanhLy = 8
}

export interface BangTongHopKiemKeBoPhan {
    id: number;
    idCoSo?: number;
    maCoSo: string;
    tenCoSo: string;
    tt: number;
    tenTaiSan: string;
    loaiTaiSan: string;
    maTaiSan: string;
    ngayTang?: Date;
    soLuongThucTeCuoiKy: number;
    soLuongTheoBoPhan: { [key: string]: number };
}

export interface BienBanTongHopKiemKeChiTiet {
    stt: number;
    id: number;
    idCoSo?: number;
    maCoSo: string;
    tenCoSo: string;
    tenTaiSan: string;
    maTaiSan: string;
    ngayTang?: Date;
    soKyPhanBo?: number;
    noiSuDung: string;
    quanLy: string;
    soLuongSoSach: number;
    nguyenGiaSoSach: number;
    gtDaPhanBoSoSach: number;
    gtConLaiSoSach: number;
    soLuongThucTe: number;
    nguyenGiaThucTe: number;
    gtDaPhanBoThucTe: number;
    gtConLaiThucTe: number;
    chenhLechSoLuong: number;
    chenhLechNguyenGia: number;
    chenhLechGtConLai: number;
    ghiChu?: string;
}
